import { useEffect, useState } from "react";

import EditCourseForm from "../../components/editCourseForm/EditCourseForm";
import { useUserData, useUserRoleData } from "../account/Account";

const EditCourse = () => {

    const { userRoleData } = useUserRoleData();
    const userRoleName = userRoleData?.title;
    const { userData } = useUserData();
    const userCustomerId = userData?.customerId

    useEffect(() => {
        if (userRoleName && userRoleName !== '') {
          if (userRoleName !== 'Admin') {
            window.location.assign('/');
          }
        }
      }, [userRoleName]);

    return (
        <>
            <EditCourseForm
                userCustomerId={userCustomerId}
            />
        </>
    )
}

export default EditCourse;